import script from "./SettingsActivateAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsActivateAccount.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsActivateAccount.vue?vue&type=style&index=0&id=55846286&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55846286"]])

export default __exports__